import { helper } from '@ember/component/helper';

import type { ValidationError } from 'webapp-types';

const validationMessage = function (params: [ValidationError[] | undefined]) {
	return params[0]?.[0]?.message;
};

const validationMessageHelper = helper(validationMessage);

export default validationMessageHelper;
